/* eslint-disable no-unused-vars */
import React from "react";
import { Col, Form, Input, Row, Spin, Button } from "antd";
import PropTypes from "prop-types";
import {
  checkNumbervalue,
  checkSpecialCharacter,
  checkSpace,
  checkAlphabets,
} from "../../utils";

const SenderForm = ({
  errorData,
  onPincodeSender = () => {},
  upperCaseSender = () => {},
  senderEmailLowerCase = () => {},
  disabled,
}) => {
  return (
    <Col lg={11} xs={11} md={11} xl={11} offset={1}>
      <Row>
        <Form.Item
          label="Name"
          name="senderName"
          rules={[
            {
              required: true,
              message: "Name is required",
              validateTrigger: "onSubmit",
            },
            () => ({
              validator(rule, value = "") {
                if (value.length > 0 && value.length < 3) {
                  return Promise.reject(
                    "Name should be between 3 to 20 charecters"
                  );
                } else {
                  return Promise.resolve();
                }
              },
              validateTrigger: "onSubmit",
            }),
          ]}
          onKeyPress={(event) => {
            if (checkAlphabets(event) || checkSpecialCharacter(event)) {
              event.preventDefault();
            }
          }}
        >
          <Input
            placeholder="Enter name here"
            type="text"
            maxLength={20}
            onBlur={upperCaseSender}
            disabled={disabled}
            onKeyPress={(e) => {
              if (/[^A-Za-z_(-) ]/.test(e.key)) {
                e.preventDefault();
              }
              if (e.target.value.length >= 20) {
                e.preventDefault();
              }
            }}
            onKeyDown={(e) => {
              if (!/[a-zA-Z]/.test(e.target.value)) e.target.value = "";
            }}
          />
        </Form.Item>
      </Row>
      <Row>
        <Form.Item
          name="senderPincode"
          label="PIN code"
          rules={[
            {
              required: disabled ? false : true,
              message: "Please enter a valid PIN code",
            },
            () => ({
              validator(rule, value = "") {
                if (!disabled) {
                  if (value.length < 0) {
                    return Promise.reject("Please enter a valid PIN code");
                  } else if (value.length > 0 && value.length < 6) {
                    return Promise.reject("Please enter 6 digits PIN code");
                  } else if (parseInt(value.substring(1, 0)) === 0) {
                    return Promise.reject("PIN number should not be 0");
                  } else if (errorData?.Status === "Error") {
                    return Promise.reject("Invalid PIN code");
                  } else {
                    return Promise.resolve();
                  }
                } else {
                  return Promise.resolve();
                }
              },
              validateTrigger: "onSubmit",
            }),
          ]}
          validateStatus={errorData?.Status === "Error" ? "error" : "none"}
          help={errorData?.Status === "Error" ? errorData?.Message : null}
          onKeyPress={(event) => {
            if (
              checkNumbervalue(event) ||
              checkSpecialCharacter(event) ||
              checkSpace(event)
            ) {
              event.preventDefault();
            }
          }}
        >
          <Input
            placeholder="Enter PIN code"
            onChange={onPincodeSender}
            maxLength={6}
            disabled={disabled}
          />
        </Form.Item>
      </Row>
      <Row>
        <Form.Item
          name="senderAddressLine1"
          label="Address line 1"
          rules={[
            {
              required: true,
              message: "Please enter a valid address",
              validateTrigger: "onSubmit",
            },
            () => ({
              validator(rule, value = "") {
                if (value.length > 0 && value.length < 5) {
                  return Promise.reject(
                    "Address should be between 5 to 50 charecters"
                  );
                } else {
                  return Promise.resolve();
                }
              },
              validateTrigger: "onSubmit",
            }),
          ]}
        >
          <Input
            placeholder="Enter address line 1"
            type="text"
            maxLength={150}
            disabled={disabled}
          />
        </Form.Item>
      </Row>
      <Row>
        <Form.Item label="Address line 2" name="senderAddressLine2">
          <Input
            placeholder="Enter address line 2"
            type="text"
            disabled={disabled}
          />
        </Form.Item>
      </Row>
    
      <Row>
        <Form.Item name="senderAreaName" label="Area name">
          <Input placeholder="Enter area name" />
        </Form.Item>
      </Row>
      <Row>
        <Form.Item
          name="senderCity"
          label="City"
          rules={[
            {
              required: true,
              message: "Sender's city is required",
            },
          ]}
          onKeyPress={(event) => {
            if (checkAlphabets(event) || checkSpecialCharacter(event)) {
              event.preventDefault();
            }
          }}
        >
          <Input placeholder="Enter city" disabled />
        </Form.Item>
      </Row>
      <Row>
        <Form.Item
          name="senderState"
          label="State"
          rules={[
            {
              required: true,
              message: "Sender's state is required",
            },
          ]}
          onKeyPress={(event) => {
            if (checkAlphabets(event) || checkSpecialCharacter(event)) {
              event.preventDefault();
            }
          }}
        >
          <Input placeholder="Enter state" disabled />
        </Form.Item>
      </Row>
      <Row>
        <Form.Item
          name="senderMobileNumber"
          label="Mobile number"
          type="number"
          rules={[
            {
              required:  false,
              message: "Please enter a valid phone number",
            },
            () => ({
              validator(rule, value = "") {
                if (!disabled) {
                  if (value.length > 0 && value.length < 10) {
                    return Promise.reject(
                      "Please enter 10 digits phone number"
                    );
                  } else if (parseInt(value.substring(1, 0)) === 0) {
                    return Promise.reject("Mobile number should not be 0");
                  } else {
                    return Promise.resolve();
                  }
                } else {
                  return Promise.resolve();
                }
              },
              validateTrigger: "onSubmit",
            }),
          ]}
          onKeyPress={(event) => {
            if (
              checkNumbervalue(event) ||
              checkSpecialCharacter(event) ||
              checkSpace(event)
            ) {
              event.preventDefault();
            }
          }}
        >
          <Input
            placeholder="Enter phone number"
            maxLength={10}
            disabled={disabled}
          />
        </Form.Item>
      </Row>
      <Row>
        <Form.Item
          name="senderEmail"
          label="Email Address"
          rules={[
            {
              type: "email",
              message: "Give the correct email",
            },
          ]}
          onKeyPress={(event) => {
            if (checkSpace(event)) {
              event.preventDefault();
            }
          }}
        >
          <Input
            placeholder="Enter email address"
            maxLength={50}
            onBlur={senderEmailLowerCase}
            disabled={disabled}
          />
        </Form.Item>
      </Row>
    </Col>
  );
};
SenderForm.PropTypes = {
  upperCaseSender: PropTypes.func,
  onPincodeSender: PropTypes.func,
};
export default SenderForm;
